import {
  ProductCaution,
  ProductCautionDisplayArea,
  ProductCautionTemperature,
} from "@/generated/open-api/schemas";

export type IsActiveProductCautionConditions = {
  area: ProductCautionDisplayArea;
  variantId?: number;
  temperature?: ProductCautionTemperature;
};

/**
 * product_variant_idsとtemperatureがともにnull => 指定したエリアですべての商品に対してに注記を表示する
 * product_variant_idsがnull => 指定したエリアでtemperatureが一致する商品に対してに注記を表示する
 * temperatureがnull => 指定したエリアでproduct_variant_idsに一致する商品に対してに注記を表示する
 * product_variant_idsとtemperatureがともにnullでない => 指定したエリアでどちらかの条件に一致する商品に対してに注記を表示する
 * @param caution
 * @param conditions
 * @returns
 */
export const isActiveProductCaution = (
  caution: ProductCaution,
  conditions: IsActiveProductCautionConditions
) => {
  if (!caution.is_active) return false;
  if (!caution.display_areas.includes(conditions.area)) return false;
  // variantIdsもtemperatureも指定されていない場合は全ての商品の注意事項として表示する
  if (!caution.product_variant_ids && !caution.temperature) return true;

  const variantIds = caution.product_variant_ids;
  const cationTemperature = caution.temperature;

  if (variantIds && conditions.variantId) {
    // or条件で、variantIdsの中にvariantIdが含まれているかを調べて次の条件に進む
    if (variantIds.includes(conditions.variantId)) return true;
  }

  if (cationTemperature && conditions.temperature) {
    // or条件で、temperatureが一致するかを調べるかを調べて次の条件に進む
    if (cationTemperature === conditions.temperature) return true;
  }

  return false;
};
